import { CollateralHistoryDetailRecord } from '@tassat/fred-definitions';
import { SecurityCurrencyAssetPair } from '@tassat/fred-extended-definitions';
import { stripPrefix } from '@tassat/utility';

import { IReleaseFormErrors, IReleaseFormValues } from './types';

export const validateRelease = async (
    values: IReleaseFormValues,
    opts: {
        errors: IReleaseFormErrors;
        pledgeAvailableAssetAmount: CollateralHistoryDetailRecord['AssetAmount'];
        assetPair?: SecurityCurrencyAssetPair;
    }
): Promise<IReleaseFormErrors> => {
    const { errors, pledgeAvailableAssetAmount, assetPair } = opts;

    const realAssetAmount = Number(stripPrefix(values.AssetAmount, `${assetPair?.security?.Ticker} `)
        .replace(/,/g, ''));

    const availableAmount = pledgeAvailableAssetAmount ? parseFloat(pledgeAvailableAssetAmount) : 0;
        if (!realAssetAmount) {
            errors.AssetAmount = 'Please enter an amount to release';
        } else if (realAssetAmount > availableAmount) {
            errors.AssetAmount = `Amount must not exceed the available ${assetPair?.security?.Ticker ?? ''} balance of the post`;
        }

    return errors;
};